/**
 * @generated SignedSource<<42e113fcca26851382592640088ff80f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareRequestsDeclineMutation$variables = {
  accessRequestId: string;
};
export type ShareRequestsDeclineMutation$data = {
  readonly declineNoteAccessRequest: {
    readonly note: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_sharedWith" | "ShareRequests_noteAccessRequests">;
    };
  } | null;
};
export type ShareRequestsDeclineMutation = {
  response: ShareRequestsDeclineMutation$data;
  variables: ShareRequestsDeclineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessRequestId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accessRequestId",
    "variableName": "accessRequestId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareRequestsDeclineMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeclineNoteAccessRequestMutation",
        "kind": "LinkedField",
        "name": "declineNoteAccessRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareRequests_noteAccessRequests"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareMeetingModal_sharedWith"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareRequestsDeclineMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeclineNoteAccessRequestMutation",
        "kind": "LinkedField",
        "name": "declineNoteAccessRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteAccessRequestNode",
                "kind": "LinkedField",
                "name": "pendingAccessRequests",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "requestor",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGuest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isConfigured",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "07f659478f263b2b2256544405548ffb",
    "id": null,
    "metadata": {},
    "name": "ShareRequestsDeclineMutation",
    "operationKind": "mutation",
    "text": "mutation ShareRequestsDeclineMutation(\n  $accessRequestId: ID!\n) {\n  declineNoteAccessRequest(accessRequestId: $accessRequestId) {\n    note {\n      id\n      ...ShareRequests_noteAccessRequests\n      ...ShareMeetingModal_sharedWith\n    }\n  }\n}\n\nfragment ShareMeetingModal_sharedWith on Note {\n  noteuserSet {\n    id\n    accessType\n    user {\n      id\n      email\n      fullName\n      image\n      isExternal\n      isGuest\n      isConfigured\n    }\n  }\n}\n\nfragment ShareRequests_noteAccessRequests on Note {\n  pendingAccessRequests {\n    id\n    createdAt\n    requestor {\n      id\n      fullName\n      email\n      image\n      isExternal\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d496065aa59edacb3122e944da197da7";

export default node;
